import { Alert, type AlertTone } from "../../../../core/Alert.js";
import { Button } from "../../../../core/Button.js";
import { DescriptionList } from "../../../../core/DescriptionList.js";
import { Input } from "../../../../core/Input.js";
import { FairnessCard } from "../../card/FairnessCard.js";
import type { FairnessVerifyContent } from "../../fairnessContent.js";

const VERDICT_TONE: Record<"valid" | "mismatch" | "pending", AlertTone> = {
  valid: "success",
  mismatch: "danger",
  pending: "neutral",
};

/**
 * Verifying one open: its id in, then whether the roll checks out and every input to it (the
 * seeds, the salt and nonce, the recorded and recomputed rolls), none of it truncated.
 */
export function FairnessVerify({
  title,
  description,
  openId,
  submit,
  onSubmit,
  error,
  result,
}: FairnessVerifyContent) {
  return (
    <FairnessCard title={title} description={description}>
      <form
        className="flex flex-col gap-3 sm:flex-row sm:items-end"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      >
        <Input
          label={openId.label}
          placeholder={openId.placeholder}
          value={openId.value}
          onChange={(event) => openId.onChange(event.target.value)}
          mono
          autoComplete="off"
          spellCheck={false}
          className="min-w-0 flex-1"
        />
        <Button
          type="submit"
          loading={submit.busy}
          disabled={submit.disabled}
          className="max-sm:w-full"
        >
          {submit.busy ? submit.busyLabel : submit.label}
        </Button>
      </form>
      {error && <Alert tone="danger">{error}</Alert>}
      {result && (
        <div className="flex flex-col gap-4">
          <Alert tone={VERDICT_TONE[result.verdict.status]}>{result.verdict.label}</Alert>
          <DescriptionList items={result.facts} />
        </div>
      )}
    </FairnessCard>
  );
}
